import React, { useEffect } from "react";
import PropTypes from "prop-types";
import TextInput from "../common/formfields/TextInput"
import TextArea from "../common/formfields/TextArea"
import DateTimeInput from "../common/formfields/DateTimeInput"
import SelectInput from "../common/formfields/SelectInput"

const EventForm = ({
    event,
    groups,
    routes,
    onSave,
    onCancel,
    onChange,
    saving = false,
    errors = {}
}) => {
    return (
        <form onSubmit={onSave} className="">
            {errors.onSave && (
                <div className="alert alert-danger" role="alert">
                    {errors.onSave}
                </div>
            )}

            <TextInput
                name="name"
                type="text"
                label="Title"
                maxLength="100"
                value={event.name}
                onChange={onChange}
                error={errors.name}
            />

            <TextInput
                name="location"
                type="text"
                label="Location"
                maxLength="100"
                value={event.location}
                onChange={onChange}
                error={errors.location}
            />

            {groups ?
                <SelectInput
                    name="groupId"
                    label="Participating Group"
                    value={event.groupId || ""}
                    defaultOption="Select Group"
                    options={groups}
                    onChange={onChange}
                    error={errors.group}
                />
                : "" }

            {routes ?
                <SelectInput
                    name="routeId"
                    label="Route"
                    value={event.routeId || ""}
                    defaultOption="Available Routes (Shared with Group)"
                    options={routes}
                    onChange={onChange}
                    error={errors.route}
                />
                : "" }

            <div className="row">
                <div className="col-6">
                    <DateTimeInput name="startDate" label="Starts" value={event.startDate} error={errors.startDate} onChange={onChange} />
                </div>
                <div className="col-6">
                    <DateTimeInput name="finishDate" label="Ends" value={event.finishDate} error={errors.finishDate} onChange={onChange} />
                </div>
            </div>

            <TextArea
                name="description"
                label="Description"
                maxLength="2000"
                cols="75"
                rows="6"
                value={event.description}
                onChange={onChange}
                error={errors.description}
            />


            <button type="submit" disabled={saving} className="btn btn-info float-right">
                {saving ? "Saving..." : "Save"}
            </button>
            <button className="btn btn-link float-right mr-1" onClick={onCancel}>
                Cancel
            </button>


        </form>

    );
}

EventForm.propTypes = {
    groups: PropTypes.array,
    errors: PropTypes.object,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    saving: PropTypes.bool
}

export default EventForm;


// WEBPACK FOOTER //
// ./src/components/events/EventForm.js